module.exports = __webpack_public_path__ + "img/circle-yellow.514907f9.png";